import styles from "./Mail.module.scss";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import TitleUpdater from "../../../components/shared/title/TitleUpdater";
import SelectComponent from "../../../components/shared/select/SelectComponent";
import InputComponent from "../../../components/shared/input/InputComponent";
import MainButton from "../../../components/shared/button/MainButton";
import { AzerpoctService } from "../../../services/azerpoct.service";
import { BankCardsServices } from "../../../services/bankCards.service";
import {
  ApiPaginationResponse,
  AzerpoctIndexRegion,
  AzerpoctRegionData,
  azerPostOrder,
  BankCardType,
  DeliveryPriceResponse,
  OrderPackagesDataType,
} from "../../../interface/site.interface";
import OrderRow from "../../../components/pages/courier/OrderRow";
import { CourierServices } from "../../../services/courier.service";
import Spinner from "../../../components/shared/spinner/Spinner";
import PackagesModal from "../../../components/pages/admin-panels/courier/PackagesModal";
import Card from "../../../components/pages/card/Card";
import { toast } from "react-toastify";
import ArrowImage from "../../../assets/images/pages/login/CaretLeft.svg";
import CalendarImg from "../../../assets/images/packages/CalendarDots.svg";
import PhoneInputComponent from "../../../components/shared/input-phone-component/PhoneInputComponent";
import { useSite } from "../../../context/TranslationContext";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { fetchTranslation } from "../../../redux/Slices/translationDataSlice";
import CardSelectModal from "../../../components/shared/card-select-modal/CardSelectModal";
import PaymentStatusModal from "../../../components/shared/payment-status-modal/PaymentStatusModal";
import PaymentMethodModal from "../../../components/shared/payment-method-modal/PaymentMethodModal";
import NoCardsModal from "../../../components/shared/no-cards-modal/NoCardsModal";
import { useServiceDebt } from "../../../hooks/useServiceDebt";
import ServiceDebtOverlay from "../../../components/shared/service-debt-overlay/ServiceDebtOverlay";

const Courier: React.FC = () => {
  const { serviceDebt, orderDebt } = useServiceDebt();
  const [formValues, setFormValues] = useState({
    phone: "",
    address: "",
    location_note: "",
    date: "",
  });

  const [azerpoctRegions, setAzerpoctRegions] = useState<AzerpoctRegionData[]>(
    []
  );
  const dispatch = useDispatch<AppDispatch>();

  const { data } = useSelector((state: RootState) => state.translationData);
  const [azerpoctRegionsIndx, setAzerpoctRegionsIndx] = useState<string>("");
  const [poctIndex, setPoctIndex] = useState<AzerpoctIndexRegion[]>([]);
  const [selectedPoctIndexId, setSelectedPoctIndexId] = useState<string>("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedPackages, setSelectedPackages] = useState<number[]>([]);
  const [deliveryDate, setDeliveryDate] = useState("");
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [azerpostOrder, setAzerpostOrder] = useState<azerPostOrder[]>([]);
  const [packages, setPackages] = useState<OrderPackagesDataType[]>([]);
  const [orderHistoryLoading, setOrderHistoryLoading] = useState(true);
  const [responseCalculate, setResponseCalculate] =
    useState<DeliveryPriceResponse | null>(null);
  const [paginationData, setPaginationData] =
    useState<ApiPaginationResponse<azerPostOrder> | null>(null);
  const [minDate, setMinDate] = useState<string>("");
  const [maxDate, setMaxDate] = useState<string>("");
  const [selectedPackageObjects, setSelectedPackageObjects] = useState<
    OrderPackagesDataType[]
  >([]);
  const [phoneCode, setPhoneCode] = useState("50");
  const [showAllPackages, setShowAllPackages] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [cards, setCards] = useState<BankCardType[]>([]);
  const [isCardModalOpen, setIsCardModalOpen] = useState(false);
  const [isPaymentStatusOpen, setIsPaymentStatusOpen] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [isCardPaymentLoading, setIsCardPaymentLoading] = useState(false);
  const [pendingPayload, setPendingPayload] = useState<any>(null);
  const [isPaymentMethodModalOpen, setIsPaymentMethodModalOpen] = useState(false);
  const [paymentErrorMessage, setPaymentErrorMessage] = useState("");
  const [isNoCardsModalOpen, setIsNoCardsModalOpen] = useState(false);
  const language = useSelector((state: RootState) => state.language.language);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      await AzerpoctService.getAzerpoctRegions().then((res) => {
        setAzerpoctRegions(res.data);
      });
      await AzerpoctService.getAzerpoctOrders().then((res) => {
        setAzerpostOrder(res.data.original.data);
        setOrderHistoryLoading(false);
        setPaginationData(res?.data.original);
      });
      await CourierServices.getAllPackages().then((res) => {
        setPackages(res?.data.original);
      });
    };

    fetchData();
  }, [language]);

  useEffect(() => {
    if (azerpoctRegionsIndx) {
      AzerpoctService.getPostIndexByRegion(azerpoctRegionsIndx).then((res) => {
        setPoctIndex(res.data.original);
        setSelectedPoctIndexId("");
      });
    }
  }, [azerpoctRegionsIndx]);

  const handlePackageClick = () => {
    setIsModalVisible(true);
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handlePostOnChange = async () => {
    const payload = {
      packages: selectedPackages,
      region: azerpoctRegionsIndx,
    };

    try {
      const response = await AzerpoctService.Post_calculatedelivery_Azerpost(
        payload
      );
      setResponseCalculate(response.data.original);
    } catch (error) {}
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const validationErrors: { [key: string]: string } = {};

    if (!azerpoctRegionsIndx) {
      validationErrors.region_id = "Rayon seçin";
    }
    if (!selectedPoctIndexId) {
      validationErrors.post_zip = "Poçt indeksini seçin";
    }
    if (selectedPackages.length === 0) {
      validationErrors.packages_list = data?.select_package || "Bağlama seçin";
    }
    if (!formValues.address || formValues.address.trim() === "") {
      validationErrors.address = "Ünvan boş ola bilməz";
    }
    if (!formValues.phone || formValues.phone.trim().length < 7) {
      validationErrors.phone = "Telefon nömrəsini daxil edin";
    }
    if (!deliveryDate) {
      validationErrors.date = "Tarix seçin";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const payload = {
      packages_list: selectedPackages,
      region_id: azerpoctRegionsIndx,
      post_zip: selectedPoctIndexId,
      address: formValues.address,
      phone: phoneCode + formValues.phone,
      date: deliveryDate,
    };

    setPendingPayload(payload);
    setIsPaymentMethodModalOpen(true);
  };

  const handleSelectBalancePayment = async () => {
    if (!pendingPayload) return;
    setIsSubmitting(true);
    try {
      const response = await AzerpoctService.PostAzerpoctOrder({ ...pendingPayload, payment_provider: "balance" });
      const original = response?.data?.original;
      setIsPaymentMethodModalOpen(false);
      if (original?.case === "success") {
        setPaymentErrorMessage("");
        setPaymentSuccess(true);
        setIsPaymentStatusOpen(true);
        setErrors({});
      } else {
        setPaymentErrorMessage(original?.content || "");
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
      }
    } catch (error: any) {
      setIsPaymentMethodModalOpen(false);
      const backendError = error.original?.content || error?.content;
      if (backendError && typeof backendError === "object") { setErrors(backendError); }
      else { setPaymentErrorMessage(typeof backendError === "string" ? backendError : ""); setPaymentSuccess(false); setIsPaymentStatusOpen(true); }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSelectCardPayment = async () => {
    setIsPaymentMethodModalOpen(false);
    setIsSubmitting(true);
    try {
      const response = await BankCardsServices.getBankCards();
      const cardsList = response.data?.data || [];

      if (cardsList.length === 0) {
        setIsNoCardsModalOpen(true);
        return;
      }

      setCards(cardsList);
      setIsCardModalOpen(true);
    } catch (error) {
      console.error("Kartlar yuklenirken xeta:", error);
      setIsNoCardsModalOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSelectDirectPayment = async () => {
    setIsPaymentMethodModalOpen(false);
    if (!pendingPayload) return;
    setIsSubmitting(true);
    try {
      const response = await AzerpoctService.PostAzerpoctOrder({
        ...pendingPayload,
        payment_provider: "yigim_direct",
      });
      const original = response?.data?.original;
      if (original?.case === "success" && original?.url) {
        window.location.href = original.url;
      } else {
        setPaymentErrorMessage(original?.content || "");
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
      }
    } catch (error: any) {
      const backendError = error.original?.content || error?.content;
      setPaymentErrorMessage(typeof backendError === "string" ? backendError : "");
      setPaymentSuccess(false);
      setIsPaymentStatusOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSelectPashaPayment = async () => {
    setIsPaymentMethodModalOpen(false);
    if (!pendingPayload) return;

    setIsSubmitting(true);
    try {
      const payloadWithPasha = {
        ...pendingPayload,
        payment_provider: "pasha",
      };

      const response = await AzerpoctService.PostAzerpoctOrder(payloadWithPasha);
      const original = response.data.original;

      if (
        original?.case === "success" &&
        original?.pay === true &&
        original?.content
      ) {
        window.location.href = original.content;
      } else if (original?.case === "success") {
        setPaymentErrorMessage("");
        setPaymentSuccess(true);
        setIsPaymentStatusOpen(true);
        setErrors({});
      } else {
        setPaymentErrorMessage("");
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
      }
    } catch (error: any) {
      const backendError = error.original?.content || error?.content;
      if (backendError && typeof backendError === "object") {
        setErrors(backendError);
      } else if (typeof backendError === "string") {
        setPaymentErrorMessage(backendError);
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
      } else {
        setPaymentErrorMessage("");
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCardSelect = async (cardId: number) => {
    if (!pendingPayload) return;

    setIsCardPaymentLoading(true);
    try {
      const payloadWithCard = {
        ...pendingPayload,
        card_id: cardId,
        payment_provider: "card",
      };

      const response = await AzerpoctService.PostAzerpoctOrder(payloadWithCard);
      const original = response.data.original;

      if (original?.case === "success") {
        setPaymentErrorMessage("");
        setPaymentSuccess(true);
        setIsPaymentStatusOpen(true);
        setErrors({});
      } else if (original?.case === "warning" || original?.case === "error") {
        setPaymentErrorMessage(original?.content || "");
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
      } else {
        setPaymentErrorMessage("");
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
      }
    } catch (error: any) {
      console.error("Kart odenisi xetasi:", error);
      const backendError = error.original?.content || error?.content;
      if (backendError && typeof backendError === "object") {
        setErrors(backendError);
      } else if (typeof backendError === "string") {
        setPaymentErrorMessage(backendError);
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
      } else {
        setPaymentErrorMessage("");
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
      }
    } finally {
      setIsCardPaymentLoading(false);
      setIsCardModalOpen(false);
    }
  };

  const handlePaymentRedirect = () => {
    setIsPaymentStatusOpen(false);
    if (paymentSuccess) {
      window.location.reload();
    }
  };

  const handlePageChange = async (urlOrPage: string | number) => {
    setOrderHistoryLoading(true);
    try {
      let apiUrl;
      if (typeof urlOrPage === "string") {
        apiUrl = urlOrPage;
      } else {
        apiUrl = `/azerpost?page=${urlOrPage}`;
      }

      const response = await AzerpoctService.getAzerpoctOrders(apiUrl);

      if (response.data?.original) {
        setAzerpostOrder(response.data.original.data || []);
        setPaginationData(response.data.original);
      }
    } catch (error) {
      toast.error(data?.error_occurred);
    } finally {
      setOrderHistoryLoading(false);
    }
  };
  useEffect(() => {}, [paginationData]);
  useEffect(() => {
    CourierServices.get_courierSetting().then((res) => {
      const setting = res.data.original;
      if (setting) {
        const formatDate = (dateString: string) => {
          const date = new Date(dateString);
          const year = date.getFullYear();
          const month = (date.getMonth() + 1).toString().padStart(2, "0");
          const day = date.getDate().toString().padStart(2, "0");
          return `${year}-${month}-${day}`;
        };

        const min = formatDate(setting.min_date);
        const max = formatDate(setting.max_date);

        setMinDate(min);
        setMaxDate(max);
      }
    });
  }, []);
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      if (!data) {
        dispatch(fetchTranslation());
      }
    } else {
      dispatch(fetchTranslation());
    }
  }, [dispatch, language]);
  useEffect(() => {
    if (selectedPackages.length > 0) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors.packages_list;
        return newErrors;
      });
    }
  }, [selectedPackages]);

  return (
    <>
      {(serviceDebt.hasDebt || orderDebt.hasDebt) && <ServiceDebtOverlay serviceDebt={serviceDebt} orderDebt={orderDebt} />}
      <TitleUpdater
        title={
          data?.colibri && data?.auth_left_sidebar_azerpost_order
            ? `${data?.colibri} | ${data?.auth_left_sidebar_azerpost_order}`
            : "Colibri"
        }
      />
      <div className={styles.contentWrapper}>
        <form id={styles.purchase} onSubmit={handleSubmit}>
          <div className={styles.row}>
            <SelectComponent
              label={data?.auth_azerpost_city}
              name="city"
              placeholder={data?.auth_courier_select}
              options={[
                { label: `${data?.auth_attorney_select}`, value: "" },
                ...azerpoctRegions.map((item) => ({
                  label: item.title,
                  value: item.id.toString(),
                })),
              ]}
              value={azerpoctRegionsIndx}
              onChange={(selectedValue) => {
                setAzerpoctRegionsIndx(selectedValue.toString());
                handlePostOnChange();
                setErrors((prevErrors) => {
                  const newErrors = { ...prevErrors };
                  delete newErrors.region_id;
                  return newErrors;
                });
              }}
              error={errors.region_id}
            />

            <SelectComponent
              label={data?.auth_azerpost_postal_code}
              name="poct_indeksi"
              placeholder={data?.auth_courier_select}
              options={poctIndex.map((item) => ({
                label: item.index_code,
                value: item.id.toString(),
              }))}
              value={selectedPoctIndexId}
              onChange={(selectedValue) => {
                setSelectedPoctIndexId(selectedValue.toString());
                setErrors((prevErrors) => {
                  const newErrors = { ...prevErrors };
                  delete newErrors.post_zip;
                  return newErrors;
                });
              }}
              disabled={!azerpoctRegionsIndx}
              error={errors.post_zip}
            />
          </div>

          <div className={styles.row}>
            <div
              onClick={() => {
                if (azerpoctRegionsIndx) {
                  handlePackageClick();
                }
              }}
              style={{ flex: 1, cursor: "pointer" }}
            >
              <SelectComponent
                label={data?.auth_azerpost_package}
                name="purchase"
                placeholder={data?.auth_courier_select}
                options={[
                  {
                    label:
                      selectedPackages.length > 0
                        ? `${selectedPackages.length} bağlama seçildi`
                        : `${data?.select_package}`,
                    value: "custom",
                  },
                ]}
                value="custom"
                onChange={() => {
                  setErrors((prevErrors) => {
                    const newErrors = { ...prevErrors };
                    delete newErrors.packages_list;
                    return newErrors;
                  });
                }}
                error={errors.packages_list}
                disabled={!azerpoctRegionsIndx}
                selectedPackagesCount={selectedPackages.length}
              />
            </div>
            {/* <div style={{ flex: "1" }}>
              <InputComponent
                label="Poçta verilmə tarixi"
                placeholder=""
                type="date"
                name="delivery_date"
                value={deliveryDate}
                onChange={(e) => setDeliveryDate(e.target.value)}
                // error={errors.address}
              />
            </div> */}
            <div
              className={styles.dateInputContainer}
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                flex: "1",
              }}
            >
              {data?.auth_azerpost_post_send_date}
              <div className={styles.dateInputWrapper}>
                {/* <span className={styles.dateLabel}>Tarix</span> */}
                <InputComponent
                  label=""
                  placeholder={data?.auth_azerpost_date}
                  type="date"
                  name="delivery_date"
                  value={deliveryDate}
                  onChange={(e) => {
                    setDeliveryDate(e.target.value);
                    setErrors((prevErrors) => {
                      const newErrors = { ...prevErrors };
                      delete newErrors.date;
                      return newErrors;
                    });
                  }}
                  min={minDate}
                  max={maxDate}
                  disabled={!minDate || !maxDate}
                  className={styles.dateInput}
                />
              </div>
              <p className={styles.errorMsg}> {errors.date}</p>
            </div>
          </div>

          <div className={styles.row}>
            <InputComponent
              label={data?.auth_azerpost_delivery_address}
              type="text"
              name="address"
              placeholder={data?.auth_azerpost_address}
              value={formValues.address}
              onChange={handleInputChange}
              error={errors.address}
            />
            {/* <InputComponent
              label="Ünvanla bağlı qeyd"
              type="text"
              name="location_note"
              placeholder="Qeyd"
              value={formValues.location_note}
              onChange={handleInputChange}
              // error={errors.address}
            /> */}
            {/* <InputComponent
              label="Mobil nömrə"
              type="tel"
              name="phone"
              placeholder="Telefon nömrəsi"
              value={formValues.phone}
              onChange={handleInputChange}
              error={errors.phone}
            /> */}
            <PhoneInputComponent
              label={data?.auth_azerpost_mobile_number}
              id="phone"
              name="phone"
              placeholder="0000000"
              value={""}
              onChange={(e) =>
                setFormValues((prevValues) => ({
                  ...prevValues,
                  phone: e.target.value.replace(phoneCode, ""),
                }))
              }
              onCodeChange={(code) => setPhoneCode(code)}
              error={errors.phone}
              combinePrefixWithNumber={true}
            />
          </div>
          <div className={styles.SelectedAllPackages}>
            {selectedPackageObjects?.length === 0 ? null : (
              <table className={styles.order_history_list_select}>
                <thead>
                  <tr>
                    <th>{data?.auth_common_tracking_code}</th>
                    <th>Məbləğ</th>
                    <th>{data?.auth_common_foreign_debt}</th>
                    <th>{data?.auth_common_local_debt}</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedPackageObjects?.map((order, index) => (
                    <OrderRow key={index} {...order} SelectedPackages={true} />
                  ))}
                </tbody>
              </table>
            )}

            {/* <div className={styles.courier_card}>
              {selectedPackageObjects?.map((order, index) => (
                <Card key={index} {...order} SelectedPackages={true} />
              ))}
            </div> */}
          </div>
          <div className={styles.form_bottom}>
            <div className={styles.purchase_details}>
              <p className={styles.purchase_delivery_cost}>
                {data?.auth_azerpost_foreign_delivery}
                <span>
                  {/* {responseCalculate?.delivery_price
                    ? responseCalculate.delivery_price
                    : 0.00}
                  AZN */}
                  {(responseCalculate?.delivery_price ?? 0).toFixed(2)}
                  AZN
                </span>
              </p>

              <p className={styles.purchase_courier_cost}>
                {data?.auth_azerpost_courier_service}
                <span>
                  {(responseCalculate?.courier_price ?? 0).toFixed(2)}
                  AZN
                </span>
              </p>

              <p className={styles.purchase_total_cost}>
                {data?.auth_azerpost_total_amount}
                <span>
                  {(
                    (responseCalculate?.delivery_price ?? 0) +
                    (responseCalculate?.courier_price ?? 0)
                  ).toFixed(2)}{" "}
                  AZN
                </span>
              </p>
            </div>
            <MainButton
              text={data?.auth_azerpost_confirm}
              type="button"
              onClick={handleSubmit}
              className={styles.form_submitBtn}
              disabled={isSubmitting}
            />
          </div>
        </form>
        <div id={styles.order_list}>
          <div className={styles.pagination_part}>
            <p className={styles.pagination_title}>
              {data?.auth_azerpost_order_history}
            </p>
            {(paginationData?.current_page === 1 &&
              paginationData?.next_page_url === null) ||
              (paginationData && (
                <div className={styles.pagination}>
                  <img
                    src={ArrowImage}
                    className={`${styles.pagination_arrow_left} ${
                      !paginationData.prev_page_url ? styles.disabled : ""
                    }`}
                    alt="Prev"
                    onClick={() => {
                      if (paginationData.prev_page_url) {
                        handlePageChange(paginationData.prev_page_url);
                      }
                    }}
                  />

                  {[...Array(paginationData.last_page)].map((_, index) => {
                    const page = index + 1;
                    return (
                      <p
                        key={page}
                        className={`${styles.pagination_count} ${
                          paginationData.current_page === page
                            ? styles.active
                            : ""
                        }`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </p>
                    );
                  })}

                  <img
                    src={ArrowImage}
                    className={`${styles.pagination_arrow_right} ${
                      !paginationData.next_page_url ? styles.disabled : ""
                    }`}
                    alt="Next"
                    onClick={() => {
                      if (paginationData.next_page_url) {
                        handlePageChange(paginationData.next_page_url);
                      }
                    }}
                  />
                </div>
              ))}
          </div>
          {orderHistoryLoading ? (
            <div className={styles.loadingWrapper}>
              <Spinner size="large" />
            </div>
          ) : azerpostOrder.length === 0 ? (
            <div className={styles.empty}>
              {data?.auth_common_order_history_empty}
            </div>
          ) : (
            <table className={styles.order_history_list}>
              <thead>
                <tr>
                  <th>{data?.auth_common_tracking_code}</th>
                  <th>{data?.address}</th>
                  <th>{data?.auth_azerpost_date}</th>
                  <th>{data?.auth_courier_payment_type}</th>
                  <th>{data?.auth_common_shipping_price}</th>
                  <th>{data?.price}</th>
                  <th>{data?.auth_azerpost_total_amount}</th>
                  <th>{data?.status}</th>
                </tr>
              </thead>
              <tbody>
                {azerpostOrder?.map((order, index) => (
                  <OrderRow key={index} {...order} Azerpost={true} />
                ))}
              </tbody>
            </table>
          )}

          <div className={styles.courier_card}>
            {azerpostOrder?.map((order, index) => (
              <Card key={index} {...order} Azerpost={true} />
            ))}
          </div>
        </div>
        {isModalVisible && (
          <PackagesModal
            visible={isModalVisible}
            onClose={() => setIsModalVisible(false)}
            packages={packages || []}
            selectedPackages={selectedPackages}
            setSelectedPackages={setSelectedPackages}
            handlePostOnChange={handlePostOnChange}
            setSelectedPackageObjects={setSelectedPackageObjects}
            showAllPackages={showAllPackages}
            setShowAllPackages={setShowAllPackages}
          />
        )}

        <PaymentMethodModal
          isOpen={isPaymentMethodModalOpen}
          onClose={() => setIsPaymentMethodModalOpen(false)}
          onSelectCard={handleSelectCardPayment}
          // onSelectPasha={handleSelectPashaPayment}
          onSelectBalance={handleSelectBalancePayment}
          onSelectDirectPay={handleSelectDirectPayment}
          amount={`${(
            (responseCalculate?.delivery_price ?? 0) +
            (responseCalculate?.courier_price ?? 0)
          ).toFixed(2)} AZN`}
          translationData={data}
          isLoading={isSubmitting}
        />

        <CardSelectModal
          isOpen={isCardModalOpen}
          onClose={() => setIsCardModalOpen(false)}
          onSelectCard={handleCardSelect}
          cards={cards}
          isLoading={isCardPaymentLoading}
          amount={`${(
            (responseCalculate?.delivery_price ?? 0) +
            (responseCalculate?.courier_price ?? 0)
          ).toFixed(2)} AZN`}
          translationData={data}
        />

        <PaymentStatusModal
          isOpen={isPaymentStatusOpen}
          isSuccess={paymentSuccess}
          onClose={() => setIsPaymentStatusOpen(false)}
          onRedirect={handlePaymentRedirect}
          errorMessage={paymentErrorMessage}
          translationData={data}
        />

        <NoCardsModal
          isOpen={isNoCardsModalOpen}
          onClose={() => setIsNoCardsModalOpen(false)}
          translationData={data}
        />
      </div>
    </>
  );
};

export default Courier;
